module.exports = __webpack_public_path__ + "media/honey-icons/icon-thumb-down copy-169fce6c.svg";